<template>
    <div>
        <div class="row" v-if="!taskId">
            <div class="col-lg-6 col-12">
                <button
                    type="button"
                    class="btn btn-secondary text-center w-100"
                    @click.prevent="showSelectTaskComponent = true"
                >
                    <i class="icofont-search-1"></i>
                    {{ trans('Select a task') }}
                </button>
            </div>
            <div class="col-lg-6 col-12">
                <button
                    v-if="canCreateTask"
                    type="button"
                    class="btn btn-secondary text-center w-100"
                    @click.prevent="showCreateTaskComponent = true"
                >
                    <i class="icofont-plus"></i>
                    {{ trans('Create task') }}
                </button>
            </div>
        </div>
        <div v-if="!loading">
            <div class="fieldset-wrap">
                <fieldset class="fieldset mb-2 selected-task-div">
                    <legend>
                        <i class="icofont-tasks-alt"></i>

                        <span
                            :class="{
                                'font-italic': task.deleted_at,
                            }"
                        >
                            {{ task.title }}
                        </span>
                        <button 
                            v-if="canShowTaskEditButton"
                            type="button" 
                            @click.prevent="showUpdateTaskComponent = true"
                        >
                            <i class="icofont-ui-edit ml-2"></i>
                        </button>
                    </legend>
                    <div class="fieldset__buttons">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click.prevent="showSelectTaskComponent = true"
                        >
                            <i class="icofont-search-1"></i>
                        </button>
                        <button
                            v-if="canCreateTask"
                            type="button"
                            class="btn btn-primary"
                            @click.prevent="showCreateTaskComponent = true"
                        >
                            <i class="icofont-plus"></i>
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-lg-5 col-12 p-0">
                            <div class="col-12 d-flex flex-column" v-if="task.project">
                                <div class="row">
                                    <div class="col-1">
                                        <i class="icofont-chart-flow-2"></i>
                                    </div>
                                    <div
                                        class="col-6 text-break pl-1"
                                        :class="{
                                            'font-italic': task.project.deleted_at,
                                        }"
                                    >
                                        {{ task.project.title }}
                                    </div>
                                    <span class="pl-2" v-if="task.project.internal_id != null">
                                        &nbsp;
                                        <b>-</b>
                                        &nbsp;
                                        {{ task.project.internal_id }}
                                    </span>
                                </div>
                            </div>
                            <div v-else class="col-12 d-flex flex-column">
                                <div class="d-flex align-items-center">
                                    <p class="m-0">
                                        <i class="icofont-chart-flow-2"></i>
                                        -
                                    </p>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-column" v-if="task.client">
                                <span
                                    :class="{
                                        'font-italic': task.client.deleted_at,
                                    }"
                                >
                                    <i
                                        v-if="task.client.type === 'company'"
                                        class="icofont-building-alt"
                                    ></i>
                                    <i
                                        v-if="task.client.type === 'contact'"
                                        class="icofont-user-alt-3"
                                    ></i>
                                    <span>
                                        {{ task.client.title }}
                                    </span>
                                </span>
                            </div>
                            <div v-else class="col-12 d-flex flex-column">
                                <div class="align-items-center">
                                    <p class="m-0">
                                        <i class="icofont-user-alt-3"></i>
                                        -
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 d-flex flex-column" v-if="task.location">
                                <span class="d-flex align-items-center">
                                    <i class="icofont-location-pin"></i>
                                    <span class="d-flex flex-column ml-1">
                                        <span>
                                            {{ task.location.street + ' ' + task.location.number }}
                                            <span v-if="task.location.bus">
                                                {{ task.location.bus }}
                                            </span>
                                            <span class="text-nowrap">
                                                {{ task.location.zip }}&nbsp;{{
                                                    task.location.city
                                                }}
                                            </span>
                                        </span>

                                        <span>
                                            {{ task.location.country }}
                                        </span>
                                    </span>
                                </span>
                            </div>
                            <div v-else class="col-12 d-flex flex-column">
                                <div class="align-items-center">
                                    <p class="m-0">
                                        <i class="icofont-location-pin"></i>
                                        -
                                    </p>
                                </div>
                            </div>

                            <div
                                class="col-12 d-flex align-items-center"
                                :class="{
                                    'font-italic': task.status.deleted_at,
                                }"
                            >
                                <span
                                    class="badge-round round-sm"
                                    :style="{
                                        backgroundColor: task.status.color,
                                    }"
                                ></span>

                                <span class="">{{ task.status.title }}</span>
                                <button
                                    v-if="canShowStatusEditButton"
                                    type="button"
                                    @click.prevent="showChangeTaskStatusComponent = true"
                                >
                                    <i class="icofont-ui-edit ml-2"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 d-flex align-items-center">
                            <div class="task-work-log-container w-100">
                                <task-work-log-progress-bar
                                    :taskId="taskId"
                                    :is-loaded="loadProgressBar"
                                ></task-work-log-progress-bar>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            <planning-task-status-form-component
                v-if="showChangeTaskStatusComponent"
                @close="showChangeTaskStatusComponent = false"
                :task-id="taskId"
                @statusUpdated="statusUpdated"
            ></planning-task-status-form-component>
        </div>
        <select-task-component
            v-if="showSelectTaskComponent"
            @close="showSelectTaskComponent = false"
            @taskSelected="changeTask({ taskId: $event, isNew: false })"
        ></select-task-component>
        <task-form-component
            v-if="showCreateTaskComponent"
            @close="showCreateTaskComponent = false"
            :planning="true"
            @info="changeTask({ taskId: $event, isNew: true })"
        ></task-form-component>
        <task-form-component
            v-if="showUpdateTaskComponent"
            @close="showUpdateTaskComponent = false"
            :planning="true"
            :task="task"
            @info="changeTask({ taskId: $event, isNew: false, fromPlanning: true })"
            @status="updateSlotsAfterStatusChange({ taskId: $event })"
        ></task-form-component>
    </div>
</template>

<script>
import FormComponent from '../../task/FormComponent';
import SelectTaskComponent from '../../schedule/widgets/SelectTaskComponent';
import TaskWorkLogProgressBar from '../../schedule/widgets/TaskWorkLogProgressBar';
import PlanningTaskStatusFormComponent from '../../schedule/widgets/PlanningTaskStatusFormComponent';
import { emitter } from '../../../plugins/Mitt';
import { mapGetters } from 'vuex';

export default {
    components: {
        SelectTaskComponent,
        TaskWorkLogProgressBar,
        TaskFormComponent: FormComponent,
        PlanningTaskStatusFormComponent,
    },
    props: {
        canCreateTask: {
            type: Boolean,
            required: false,
            default: false,
        },
        canChangeStatus: {
            type: Boolean,
            required: false,
            default: false,
        },
        modelValue: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            loading: true,
            showSelectTaskComponent: false,
            showCreateTaskComponent: false,
            showChangeTaskStatusComponent: false,
            taskId: this.modelValue,
            task: {},
            // task select modal
            selectTaskModal: {
                active: false,
            },
            isProgressBarVisible: false,
            showUpdateTaskComponent: false,
            loadProgressBar: false,
        };
    },
    computed: {
        ...mapGetters({
            hasPermission: 'permissions/hasPermission'
        }),
        
        canShowTaskEditButton() {
            // If no project, always show based on original logic
            if (!this.task.project) {
                return true;
            }
            // If has project, check project-edit permission
            return this.hasPermission('project-edit');
        },
        
        canShowStatusEditButton() {
            // If no project, show based on canChangeStatus prop
            if (!this.task.project) {
                return this.canChangeStatus;
            }
            // If has project, check both canChangeStatus AND project-edit permission
            return this.canChangeStatus && this.hasPermission('project-edit');
        }
    },
    methods: {
        getTaskById() {
            if (!this.taskId) {
                return;
            }
            const url = route('task.get-by-id', this.taskId);

            axios.get(url).then((response) => {
                this.loadProgressBar = false;
                this.task = response.data;
                this.loading = false;
            });
        },
        changeTask({ taskId, isNew, fromPlanning = false }) {
            this.showSelectTaskComponent = false;
            this.showCreateTaskComponent = false;
            this.taskId = taskId;
            this.getTaskById();

            // This shoud be in another place?
            if (isNew) {
                emitter.emit('new-task-created', { taskId: taskId });
            } else {
                if (fromPlanning) {
                    this.loadProgressBar = true;
                    emitter.emit('task-updated-planning', { taskId: taskId });
                }
            }
        },
        statusUpdated() {
            this.showChangeTaskStatusComponent = false;
            emitter.emit('task-updated-planning', { taskId: this.taskId });
            this.getTaskById();
        },
        updateSlotsAfterStatusChange({ taskId }) {
            emitter.emit('task-updated-planning', { taskId: taskId });
        },
    },
    watch: {
        taskId() {
            this.$emit('update:modelValue', this.taskId);
        },
    },
    created() {
        this.getTaskById();
    },
};
</script>

<style scoped>
.fieldset.task-detail p {
    margin-bottom: 0;
}
</style>
